import {
  createI18nUsageReporter,
  I18N_USAGE_INIT_OPTIONS,
} from '@cutr/constants/i18n-usage';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const i18nUsage = createI18nUsageReporter('cutlist');

/** Promise that resolves when i18n has finished initialising. Await before using i18n. */
export const i18nInit = i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(i18nUsage.postProcessor)
  .init({
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    load: 'languageOnly',
    ns: ['translation'],
    debug: false,
    fallbackLng: ['nl', 'en', 'dev'],
    fallbackNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    ...I18N_USAGE_INIT_OPTIONS,
  });

export default i18n;
